import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.flighs
)

export const selectFlights = createSelector(
    baseSelector,
    (state) => state.flights
)

export const selectFlightsError = createSelector(
    baseSelector,
    (state) => state.flightsError
)

export const selectFlightsLoading = createSelector(
    baseSelector,
    (state) => state.isFlightsLoading
)

export const selectFlightsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFlightsFirstLoad
)